import Softwares from "./software_root/software";

import Message_root from "./message_root/message";
import Error_page from "./pages/error";
import Community from "./community_root/community";
import Account from "./profile/account";
import Login from "./profile/login";
import Tools from "./typing_master_root/tools";
import FaviconGenerator from "./favicon_root/favicon-generator";
import Word_counter from "./word-counter_root/word-counter";
import Services from "./services_root/services";
import Typing_master from "./typing_master_root/typing-master";
import ImageToPDF from "./image-to-pdf_root/image-to-pdf";
import Properties_root from "./properties_root/properties";
import List_rent from "./properties_root/list-rent";
import Rent_root from "./properties_root/rent";
import Buy_property from "./properties_root/buy-property";
import Sell_property from "./properties_root/sell-property";
import AudioConverter from "./audio_converter_root/audio-converter";
import Phonebook from "./phonebook_root/phonebook";
import Phonebook_edit from "./phonebook_root/phonebook-edit";
import Install_app from "./body_root/install-app";
import Chart_root from "./cart_root/chart";
import Search_root from "./search_root/search";
import Home_page from "./home_root/home";
import Support from "./support_root/support";
export const Approutes = [
  { path: '/', name: 'Home Apps', element: <Home_page /> },
   { path: '/support', name: 'Support', element: <Support /> },
  { path: '/search', name: 'search', element: <Search_root /> },
  { path: '/chart', name: 'Chart', element: <Chart_root /> },
  { path: '/install-app', name: 'Install App', element: <Install_app /> },
  { path: '/phonebook', name: 'audio converter', element: <Phonebook /> },
  { path: '/phonebook-edit', name: 'Phonebook edit', element: <Phonebook_edit /> },
  { path: '/audio-converter', name: 'audio converter', element: <AudioConverter /> },
  { path: '/properties', name: 'properties', element: <Properties_root /> },
  { path: '/rent', name: 'buy rent', element: <Rent_root /> },
  { path: '/list-rent', name: 'List rent', element: <List_rent /> },
  { path: '/buy-property', name: 'Buy property', element: <Buy_property /> },
  { path: '/sell-property', name: 'Sell property', element: <Sell_property /> },
  { path: '/software', name: 'list rent', element: <Softwares /> },
  { path: '/image-to-pdf', name: 'Image to pdf', element: <ImageToPDF /> },
  { path: '/typing-master', name: 'Typing master', element: <Typing_master /> },
  { path: '/services', name: 'Services', element: <Services /> },
  { path: '/word-counter', name: 'Free Word Counter Tool', element: <Word_counter /> },
  { path: '/favicon-generator', name: 'Free Favicon generator', element: <FaviconGenerator /> },
  { path: '/tools', name: 'Tools Wealth', element: <Tools /> },
  { path: '/message', name: 'Message', element: <Message_root /> },
  { path: '/community', name: 'Message', element: <Community /> },
  { path: '/account', name: 'Profile account', element: <Account /> },
  { path: '/login', name: 'Login account', element: <Login /> },
  { path: '/error', name: 'error', element: <Error_page /> }
];